import React from 'react';
import { renderFields } from '../../utils/RenderUtil';

/** renders a field group with 50 50 split */
export const FieldGroup5050 = props => {
  return (
    <div className="field-group-5050">
      {renderFields(props, (renderedChild, index) => (
        <div key={index} className="field-group-5050-col">
          {renderedChild}
        </div>
      ))}
    </div>
  );
};
